export default "__VITE_ASSET__Cuimk48E__"